'use client';

import React from 'react';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FinalCTA from '../_shared/sections/FinalCTA';

type Props = { lang: Locale };

const WalletFinalCTA = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  return (
    <FinalCTA
      accent="#22D3EE"
      ariaLabel={t('Wallet/FinalCTA/aria_label')}
      copy={{
        headlineA: t('Wallet/FinalCTA/title1'),
        headlineB: t('Wallet/FinalCTA/title2'),
        subhead: t('Wallet/FinalCTA/subtitle'),
        ctaPrimary: {
          label: t('Wallet/FinalCTA/cta_primary'),
          href: `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/register`,
        },
        ctaSecondary: {
          label: t('Wallet/FinalCTA/cta_secondary'),
          href: `/${lang}/contact-us`,
        },
      }}
    />
  );
};

export default WalletFinalCTA;
